import { printColors } from "../components/styles/colors";
import type { ApiProductSummary } from '../api/erp';

/** ERP list policy: 160px source-derived thumbnail, then legacy image; never posters. */
export function selectSkuThumbnail(product?: Pick<ApiProductSummary,'images'|'previews'|'thumbnails'|'image_variants'> | null): string | undefined {
    return product?.image_variants?.small
        || product?.thumbnails?.white_bg_url
        || product?.thumbnails?.original_url
        || undefined;
}

/** ERP overview-card policy: responsive preview, then full display image, then small fallback. */
export function selectSkuPreview(product?: Pick<ApiProductSummary,'images'|'previews'|'thumbnails'|'image_variants'> | null): string | undefined {
    return product?.image_variants?.grid
        || product?.previews?.white_bg_url
        || product?.previews?.original_url
        || product?.images?.white_bg_url
        || product?.images?.original_url
        || selectSkuThumbnail(product)
        || undefined;
}

/** Detail policy: prefer the 1600px white-background display image. */
export function selectSkuDetailImage(product?: Pick<ApiProductSummary,'images'|'previews'|'thumbnails'|'image_variants'> | null): string | undefined {
    return product?.image_variants?.detail
        || product?.images?.white_bg_url
        || product?.images?.original_url
        || undefined;
}


/** Match the existing App/server avatar contract before sending bytes. */
export async function prepareSupplierAvatar(file:File):Promise<File> {
    if(!['image/jpeg','image/png','image/webp','image/gif'].includes(file.type)||file.size>15*1024*1024)return file;
    const url=URL.createObjectURL(file);
    try {
        const image=new Image();image.src=url;await image.decode();
        const canvas=document.createElement('canvas');canvas.width=512;canvas.height=512;
        const context=canvas.getContext('2d');if(!context)return file;
        const side=Math.min(image.naturalWidth,image.naturalHeight);
        context.fillStyle=printColors.paper;context.fillRect(0,0,512,512);
        context.drawImage(image,(image.naturalWidth-side)/2,(image.naturalHeight-side)/2,side,side,0,0,512,512);
        const blob=await new Promise<Blob|null>(resolve=>canvas.toBlob(resolve,'image/jpeg',0.9));
        return blob?new File([blob],'avatar.jpg',{type:'image/jpeg'}):file;
    } catch {return file;} finally {URL.revokeObjectURL(url);}
}
